module.exports = __webpack_public_path__ + "img/arrow_right_b.8c8d1067.svg";